import React, { useEffect, useState } from 'react'
import classes from '@src/styles/HowItWorksWarrior.module.css'
import classNames from 'classnames'
import { useRouter } from 'next/router'

import featureImageMobile from '@src/assets/how-it-works-mobile.png'
import featureImage from '@src/assets/how-it-works.png'
import { useMediaQuery } from 'react-responsive'
import { segmentTrack } from '@src/functions/segment'
import queryString from 'query-string'
import { withAttribution } from '@src/functions/attribution'

function HowItWorks() {
  const desktop = useMediaQuery({ query: '(min-width:768px)' });
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    setIsDesktop(desktop);
  }, [desktop]);

  const history = useRouter()

  const handleButtonClick = (userType: string) => {
    // eslint-disable-next-line no-console
    console.log('handleButtonClick : userType', userType)
    // dispatch({ type: 'SET_TEMP_USER', userType })
    history.push(
      withAttribution(
        `${process.env.NEXT_PUBLIC_REDIRECT_URL}?`.concat(
          queryString.stringify({
            login: '1',
          }),
        ),
      ),
    )
    segmentTrack('User Clicks Register - Provider Portal', { userType });
  }

  const featureSrc = isDesktop ? featureImage.src : featureImageMobile.src

  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <img alt='feature' className={classes.image} src={featureSrc} />
        <div className={classes.textContainer}>
          <h2 className={classNames(classes.heading, classes.mainHeading)}>How it works</h2>
          <div className={classes.stepWrapper}>
            <ul className={classes.StepProgress}>
              <li className={classes.StepProgressItem}>
                <div className={classes.stepContent}>
                  <p className={classes.description}>
                    <strong>Find an open task</strong>, on our site, including the location, date,
                    nature of the pickup and rate offered.
                  </p>
                  <span className={classes.stepNumber}>01</span>
                </div>
              </li>
              <li className={classes.StepProgressItem}>
                <div className={classes.stepContent}>
                  <p className={classes.description}>
                    <strong>Claim the task</strong>, and we&apos;ll connect you with the customer.
                  </p>
                  <span className={classes.stepNumber}>02</span>
                </div>
              </li>
              <li className={classes.StepProgressItem}>
                <div className={classes.stepContent}>
                  <p className={classes.description}>
                    <strong>Get paid</strong> within a few working days.
                  </p>
                  <span className={classes.stepNumber}>03</span>
                </div>
              </li>
              <li className={classes.StepProgressItem}>
                <div className={classes.stepContent}>
                  <p className={classes.description}>
                    <strong>Make a booking</strong> in seconds.
                  </p>
                  <span className={classes.stepNumber}>04</span>
                </div>
              </li>
            </ul>
          </div>
          <button className={classes.primaryButton} onClick={() => handleButtonClick('provider')}>
            Join now
          </button>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
